// src/components/RegisteredUserRoute.js
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../api";

function RegisteredUserRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    const checkRegistration = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        setIsRegistered(false);
        return;
      }

      try {
        const res = await api.get("/check-register-access", {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        // If allowed is false, user is already registered
        // If allowed is true, user needs to register
        setIsRegistered(!res.data.allowed);
        setLoading(false);
      } catch (err) {
        console.error("Failed to check registration status:", err);
        setIsRegistered(false);
        setLoading(false);
      }
    };

    checkRegistration();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return isRegistered ? children : <Navigate to="/register" replace />;
}

export default RegisteredUserRoute;
